import styles from "./FormProgressBar.module.css";

type FormProgressBarProps = {
  filled: number;
  total: number;
  isDirty: boolean;
};

export function FormProgressBar({ filled, total, isDirty }: FormProgressBarProps) {
  const pct = total > 0 ? Math.round((filled / total) * 100) : 0;

  return (
    <div className={styles.progressBar}>
      <div className={styles.progressInfo}>
        <span className={styles.progressLabel}>
          {filled}/{total} fields populated
        </span>
        {isDirty && <span className={styles.unsavedPill}>Unsaved changes</span>}
        <span
          className={styles.progressPct}
          style={{
            color:
              pct >= 100
                ? "var(--color-success, #16a34a)"
                : pct > 0
                  ? "var(--color-warning, #d97706)"
                  : "var(--color-text-secondary)",
          }}
        >
          {pct}%
        </span>
      </div>
      <div className={styles.progressTrack}>
        <div
          className={styles.progressFill}
          style={{
            width: `${pct}%`,
            background:
              pct >= 100
                ? "var(--color-success, #16a34a)"
                : pct > 0
                  ? "var(--color-warning, #d97706)"
                  : "var(--color-border, #e2e8f0)",
          }}
        />
      </div>
    </div>
  );
}
